module.exports = __webpack_public_path__ + "img/fr-fr.cbb5741e.svg";